import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[adtractionScript]'
})
export class AdtractionScriptDirective implements OnInit {
  @Input() adtractionScript: string;

  constructor(private elem: ElementRef) {
  }

  ngOnInit() {
    const html = `<script defer src="https://cdn.adt356.com/jsTag?ap=${this.adtractionScript}"></script>`;

    const fragment = document.createRange().createContextualFragment(html);
    this.elem.nativeElement.appendChild(fragment);
  }
}
